<template>
  <modal v-bind="$attrs" v-on="$listeners">
    <div class="" v-if="bookingData">
      <div class="review modal-availability">
        <div class="text-center border-bottom mb-2">
          <img
            src="~rhomtrip_assets/src/img/icons/alerts/question.png"
            alt="question"
            class="icon-modal-alert"
          />
          <h2 class="modal-title">Request Availability Confirmation</h2>
          <p>
            You've selected a service departing within our booking cut-off time
            ({{ cutoffTime }}).
          </p>
        </div>

        <div class="card mb-3">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div class="item-list">
                  <span><strong>From: </strong>{{ bookingData.from }}</span>
                </div>

                <div class="item-list">
                  <span><strong>To: </strong>{{ bookingData.to }}</span>
                </div>

                <div class="item-list">
                  <span>
                    <strong>Date & Time: </strong>
                    {{ bookingData.pickupDate }} at {{ bookingData.pickupTime }}
                  </span>
                </div>

                <div class="item-list">
                  <span>
                    <strong>PAX N°: </strong>
                    {{ bookingData.passengersCount }} PAX
                  </span>
                </div>

                <div class="item-list">
                  <span>
                    <strong>Service Type: </strong>
                    {{ bookingData.vehicleCategory }}
                  </span>
                </div>

                <div class="item-list">
                  <span>
                    <strong>Vehicle: </strong>
                    {{ bookingData.vehicleName }}
                  </span>
                </div>

                <div class="item-list">
                  <span>
                    <strong>Total Charges: </strong>
                    {{ bookingData.currency.code }}
                    {{ bookingData.totalAmount }}
                    {{ bookingData.currency.symbol }}
                  </span>
                </div>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                v-if="bookingData.passenger"
              >
                <div class="item-list">
                  <span>
                    <strong>PAX: </strong>
                    {{ bookingData.passenger.fullName }}
                  </span>
                </div>
                <div class="item-list">
                  <span>
                    <strong>Email: </strong>
                    {{ bookingData.passenger.email }}
                  </span>
                </div>
                <div class="item-list">
                  <span>
                    <strong>Contact Number: </strong>
                    {{ bookingData.passenger.phone }}
                  </span>
                </div>

                <div class="item-list" v-if="bookingData.specialRequirements">
                  <span>
                    <strong>Special Requirements: </strong>
                    {{ bookingData.specialRequirements }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <base-alert type="info">
          <h4 class="subtitle mb-1 mt-1">How This Works</h4>

          <ol class="number-list">
            <li>
              <span>
                Submit — an email will be sent to the supplier to confirm
                availability.
              </span>
            </li>
            <li>
              <span>
                The customer will receive confirmation within 12–24 hours via
                email.
              </span>
            </li>
            <li>
              <span>
                If the supplier confirms availability, the customer will be
                required to complete the payment
                <strong>
                  {{ bookingData.currency.code }}
                  {{ bookingData.totalAmount }}
                  {{ bookingData.currency.symbol }}
                </strong>

                to confirm the reservation.
              </span>
            </li>
            <li>
              <span
                >If unavailable, the customer is notified automatically — no
                charge is made and no refund is needed</span
              >
            </li>
          </ol>
        </base-alert>

        <base-alert type="warning" class="mb-0 info-min">
          <i class="flaticon-warning mr-1"></i>
          <strong>Important!</strong>

          You will NOT be charged now. Payment only occurs after availability is
          confirmed and you complete the reservation.
        </base-alert>
      </div>
    </div>
    <template slot="footer">
      <base-button
        type="outline-neutral"
        class="min-button mb-0"
        @click="handleCutoffModalClose()"
      >
        Cancel
      </base-button>

      <base-button
        type="primary"
        class="min-button ml-auto mb-0"
        @click="submit()"
      >
        Submit Availability Request
      </base-button>
    </template>
  </modal>
</template>
<script>
import ServicePrice from "@/components/ServicePrice.vue";
import { mapGetters } from "vuex";
export default {
  name: "CutoffTimeConfirmationModal",
  inheritAttrs: false,
  props: {
    bookingData: {
      type: Object,
      default: () => null
    },
    cutoffTime: {
      type: String,
      default: "48 hours"
    }
  },
  methods: {
    handleCutoffModalClose() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submitAvailabilityRequest");
    }
  },
  components: {
    ServicePrice
  },
  computed: {
    ...mapGetters(["currency"])
  }
};
</script>
